<input pInputText
  type="text"
  [value]="displayValue"
  [disabled]="disabled"
  [style]="style"
  class="w-full input-quantidade"
  (keydown)="onKeyDown($event)"
  (blur)="onBlur()"
  inputmode="numeric"
  readonly />
